import { fetchLocalDev, isLocalDev } from './fetch-local-dev';
import { fetchMEventsAPI } from './fetch-m-events-api';
import { fetchProduction } from './fetch-production';

/**
 * appConfig can come from the following sources:
 * 1. in DEV environment
 *   - from locally saved file: public/layoutSettings.json
 *   - from m-events API
 * 2. in new deployment from /cms-settings/${eventId}_vmRevolution_false.json
 */
export const resolveAppConfig = async (coreSettings) => {
  if (process.env.NODE_ENV === 'development') {
    return isLocalDev(coreSettings) ? fetchLocalDev() : fetchMEventsAPI(coreSettings);
  }

  // default production flow:
  return fetchProduction(coreSettings);
};

const combine = (coreSettings) => (appConfig) => ({ coreSettings, appConfig });

export const fetchAppConfig = async (coreSettings) => resolveAppConfig(coreSettings).then(combine(coreSettings));
